import { useRef, useState } from 'react'
import Button from '../../../components/common/Button'
import MessageSection from '../../../components/common/MessageSection'
import Break from '../../../components/common/Break'
import ErrorMessage from '../../../components/common/ErrorMessage'
import fetchAPI from '../../../common/fetchAPI'
import useError from '../../../common/hooks/useError'
import ConfirmModalContent from '../../../components/common/ConfirmModalContent'
import useModal from '../../../common/hooks/useModal'

export default function BulkTaskActions() {
    const [message, setMessage] = useState('')
    const errorRef = useRef()
    const [error, setError] = useError(errorRef)
    const { setModal, setModalLoading, isModalLoading } = useModal()

    async function onUpdateProgressToOpen() {
        setError('')
        setMessage('')

        setModal(
            <ConfirmModalContent
                text={'This action cannot be reversed.'}
                onConfirm={async () => {
                    if (isModalLoading) return
                    setModalLoading(true)
                    const { error } = await fetchAPI(
                        `/v1/tasks/bulk/update-status`,
                        { from: 'accepted', to: 'open' },
                        'POST',
                    )
                    setModalLoading(false)

                    if (error) {
                        setModal(null)
                        setError(error)
                        return
                    }

                    setModal(null)
                    setMessage(
                        'Update initiated, it might take up to a minute.',
                    )
                }}
            />,
            "Are you sure you want to mark all of the app's in-progress tasks to open?",
        )
    }

    return (
        <div>
            {!!error && (
                <div ref={errorRef}>
                    <ErrorMessage onDismiss={() => setError('')}>
                        {error}
                    </ErrorMessage>
                </div>
            )}

            {!!message && (
                <>
                    <MessageSection
                        type="success"
                        onDismiss={() => setMessage('')}
                    >
                        <div>{message}</div>
                    </MessageSection>
                    <Break />
                </>
            )}

            <Button
                outline
                text="Set all in-progress to open"
                onClick={onUpdateProgressToOpen}
                isLoading={isModalLoading}
            ></Button>
        </div>
    )
}
